import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';

const Menu = (props) => {
  const data = useStaticQuery(graphql`
    query MainMenuQuery {
      allMainMenuJson {
        edges {
          node {
            name
            url
            weight
          }
        }
      }
    }
  `);
  return (
    <div id='main-menu' className='main-menu'>
      <ul>
        <li key='Home' class='home'>
          <Link to={'/'} activeClassName='active'>
            Home
          </Link>
        </li>
        <li key='Our Doctors' class='our-doctors'>
          <Link to={'/our-doctors'} activeClassName='active'>
            Our Doctors
          </Link>
        </li>
        {data.allMainMenuJson.edges.map(({ node }) => (
          <li key={node.name}>
            <Link to={node.url} activeClassName='active'>
              {node.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Menu;
